import {   $handleError  } from '@/utils';
import httpService from '@Utils/httpService';
export const INSPECTION_DASHBOARD = {
  namespaced: true,
  state: {
    // Keep alive
    loading: false,
    viewerOpened: false,
    selectedRowsData: [],
    coloredInspections: [],
    inspectionStats: {
      openStatus: 0,
      prdOverhaul: 0,
      items: [
        { category: 'Equipment', plan: 0, progress: 0, completed: 0, overdue: 0 },
        { category: 'Piping', plan: 0, progress: 0, completed: 0, overdue: 0 },
        { category: 'PRDs', plan: 0, progress: 0, completed: 0, overdue: 0 },
        { category: 'Work Orders', plan: 0, progress: 0, completed: 0, overdue: 0 },
      ],
      reportsData: [0, 0, 0],
    },
  },
  getters: {
    GET_LOADING(state) {
      return state.loading;
    },
    GET_VIEWER_OPENED(state) {
      return state.viewerOpened;
    },
    GET_SELECTED_ROWS_DATA(state) {
      return state.selectedRowsData;
    },
    GET_COLORED_INSPECTIONS(state) {
      return state.coloredInspections;
    },
    GET_INSPECTION_STATS(state) {
      return state.inspectionStats;
    },
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_VIEWER_OPENED(state, value) {
      state.viewerOpened = value;
    },
    SET_SELECTED_ROWS_DATA(state, value) {
      state.selectedRowsData = value;
    },
    SET_COLORED_INSPECTIONS(state, value) {
      state.coloredInspections = value;
    },
    SET_INSPECTION_STATS(state, value) {
      return (state.inspectionStats = value);
    },
  },
  actions: {
    RESET({ commit }) {
      commit('SET_LOADING', false);
      commit('SET_VIEWER_OPENED', false);
      commit('SET_SELECTED_ROWS_DATA', []);
      commit('SET_COLORED_INSPECTIONS', []);
      commit('SET_INSPECTION_STATS', {
        openStatus: 0,
        prdOverhaul: 0,
        items: [
          { category: 'Equipment', plan: 0, progress: 0, completed: 0, overdue: 0 },
          { category: 'Piping', plan: 0, progress: 0, completed: 0, overdue: 0 },
          { category: 'PRDs', plan: 0, progress: 0, completed: 0, overdue: 0 },
          { category: 'Work Orders', plan: 0, progress: 0, completed: 0, overdue: 0 },
        ],
        reportsData: [0, 0, 0],
      });
    },
    GET_INSPECTION_STATS({ commit }, data) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        httpService
          .post({
            url: `api/InspectionDashboard/ADNOC/Inspection-Stats`,
            data: data,
          })
          .then((res) => {
            commit('SET_INSPECTION_STATS', res.data);
            resolve(res.data);
          })
          .catch((error) => {
            $handleError(error);
            reject(error);
          })
          .finally(() => {
            commit('SET_LOADING', false);
          });
      });
    },
  },
};